import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IControlValidatorFieldValidatorFn } from '../models/control-validator.model';

// Note: Validator based on VPForm.vb CheckMinMaxValues validation
export class PercentInputValidator extends IControlValidatorFieldValidatorFn {
  static override errorKey = 'percentRange';
  static maxPercent = 9999.99;
  static minPercent = -9999.99;

  static maxOverflowException = `Value must be less than or equal to 9,999.99%`;
  static minOverflowException = `Value must be greater than or equal to -9,999.99%`;

  static validate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value: number = Number(control.value) * 100;

      if (isNaN(value)) {
        return null;
      }

      return value > PercentInputValidator.maxPercent
        ? PercentInputValidator.validationErrors(PercentInputValidator.errorKey, PercentInputValidator.maxOverflowException)
        : value < PercentInputValidator.minPercent
          ? PercentInputValidator.validationErrors(PercentInputValidator.errorKey, PercentInputValidator.minOverflowException)
          : null;
    };
  }
}
